export const downloadTaskStatus = {
  NONE: "none",
  NO_CREATED: "no-created",
  CREATED: "created",
  PROCESSING: "processing",
  COMPLETED: "completed",
  FAILED: "failed",
  CANCELLED: "cancelled",
};
